import { ContactPathsEnum } from 'modules/contactPage/routes';
import { ContractPathsEnum } from 'modules/contractsPage/routes';
import { useSidePopout } from 'modules/layout';
import { LeasingOffersPathsEnum } from 'modules/leasingOffersPage/routes';

import { theme } from 'modules/ui';
import {
  BankTouchpointAndCustomerCareAboutUs,
  BankTouchpointAndCustomerCareContacts,
  NavigationAndActionProfile,
} from 'modules/ui/icons';
import { PopoutTheme } from 'modules/ui/popout/PopoutTheme';
import { ToggleButton } from 'modules/ui/toggleButton';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ProfilePathsEnum } from 'modules/profilePage/routes';
import { BillPathsEnum } from 'modules/billsPage/routes';
import {
  SubmenuContainer,
  SubmenuItemContainer,
  SubmenuMobileButtonsContainer,
} from './styled';
import { SubmenuItem } from './SubmenuItem';

export interface SubmenuProps {
  className?: string;
}

export const Submenu: React.FC<SubmenuProps> = ({ className }) => {
  const { t } = useTranslation();
  const { closePopout, popoutTheme } = useSidePopout();

  const history = useHistory();

  const handleNavigation = (
    path: string,
    options?: {
      outside?: boolean;
    },
  ) => {
    if (options?.outside) {
      window.location.href = path;
    } else {
      history.push(path);
    }

    closePopout();
  };

  return (
    <SubmenuContainer className={className}>
      <SubmenuItemContainer>
        <SubmenuItem ariaLabel={t('header.submenu.homepage')} location="/">{t('header.submenu.homepage')}</SubmenuItem>
        <SubmenuItem ariaLabel={t('header.submenu.offers')} location={LeasingOffersPathsEnum.leasingOffers}>
          {t('header.submenu.offers')}
        </SubmenuItem>
        <SubmenuItem ariaLabel={t('header.submenu.contracts')} location={ContractPathsEnum.contracts}>
          {t('header.submenu.contracts')}
        </SubmenuItem>
        <SubmenuItem ariaLabel={t('header.submenu.bills')} location={BillPathsEnum.bills}>
          {t('header.submenu.bills')}
        </SubmenuItem>
        {/* commented for release day */}
        {/* <SubmenuItem location={ActionsPathsEnum.newRequestPage}>
          {t('header.submenu.actions')} */}
        {/* </SubmenuItem> */}
      </SubmenuItemContainer>
      <SubmenuMobileButtonsContainer>
        <ToggleButton
          text={t('header.profile')}
          icon={<NavigationAndActionProfile />}
          onClick={() => handleNavigation(ProfilePathsEnum.profilePage)}
          color={
            popoutTheme === PopoutTheme.Dark
              ? theme.colors.primaryK3
              : undefined
          }
        />
        <ToggleButton
          text={t('header.contact')}
          icon={<BankTouchpointAndCustomerCareContacts />}
          onClick={() => handleNavigation(ContactPathsEnum.contactPage)}
          color={
            popoutTheme === PopoutTheme.Dark
              ? theme.colors.primaryK3
              : undefined
          }
        />
        <ToggleButton
          text={t('header.about')}
          icon={<BankTouchpointAndCustomerCareAboutUs />}
          onClick={() =>
            handleNavigation('https://unicreditleasing.hr/home/o-nama/o-nama', {
              outside: true,
            })
          }
          color={
            popoutTheme === PopoutTheme.Dark
              ? theme.colors.primaryK3
              : undefined
          }
        />
      </SubmenuMobileButtonsContainer>
    </SubmenuContainer>
  );
};
